import { getTime, formatDate, formatPrice } from '@/utils/util'
// set function parseTime,formatTime to filter
export { parseTime } from '@/utils'
export { formatDate, formatDateAndTime, toThousandslsFilter } from '@/utils/util'

export function formatTime (date) {
  return getTime(date)
}
function pluralize (time, label) {
  return time + label
}

export function timeAgo (date) {
  const _date = new Date(date)
  const time = _date.getTime() / 1000
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) { // 小于一小时
    const min = ~~(between / 60)
    if (min <= 0) {
      return '小于一分钟'
    } else {
      return pluralize(~~(between / 60), ' 分钟前')
    }
  } else if (between < 86400) { // 小于一天
    return pluralize(~~(between / 3600), ' 小时前')
  } else if (between <= 604800) { // 小于等于七天
    return pluralize(~~(between / 86400), ' 天前')
  } else {
    return formatDate(_date)
  }
}

/* 数字 格式化 */
export function numberFormatter (num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function fileSizeFilter (limit) {
  if (typeof limit !== 'number') return
  let size = ''
  if (limit < 1 * 1024) {
    size = limit.toFixed(2) + 'B'
  } else if (limit < 1 * 1024 * 1024) {
    size = (limit / 1024).toFixed(2) + 'KB'
  } else if (limit < 1 * 1024 * 1024 * 1024) {
    size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
  } else { // 其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }

  let sizeStr = size + ''
  let len = sizeStr.indexOf('.')
  let dec = sizeStr.substr(len + 1, 2)
  if (dec === '00') { // 当小数点后为00时 去掉小数部分
    return sizeStr.substring(0, len) + sizeStr.substr(len + 3, 2)
  }
  return sizeStr
}

export function priceFilter (price) {
  return formatPrice(price)
}



// WEBPACK FOOTER //
// ./src/filters/index.js